module.exports = __webpack_public_path__ + "media/images/sp/stores/yokohama/yokohama_concept_02-2bc2c12ad667318195b1cd88fc74c75d.jpg";